<template>
  <form id="pointTypeForm" class="mx-auto col-sm-8" @submit.prevent>
    <div
      class="form-group"
      :class="{ 'has-error': errors.has('description') }"
    >
      <label for="description">{{ $t("description") }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="pointType.TPT_DSC"
        v-validate="'required'"
      />

      <small v-show="errors.has('description')" class="form-text">
        {{ errors.first("description") }}
      </small>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors.has('code') }"
    >
      <label for="code">{{ $t("code") }}</label>
      <input
        type="text"
        id="code"
        name="code"
        class="form-control"
        :placeholder="$t('ph_code')"
        v-model="pointType.TPT_COD"
        v-validate="'required'"
      />

      <small v-show="errors.has('code')" class="form-text">
        {{ errors.first("code") }}
      </small>
    </div>

    <div class="form-group">
      <label for="client">{{ $t('client') }}</label>
      <Combobox
        class="bg-white"
        name='client'
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('client')"
        label="CLI_DSC"
        :options="clients"
        :initial-value="pointType.CLI_ID"
        v-model="pointType.CLI_ID"
        :reduce="pointType => pointType.CLI_ID"
        v-validate="'required'"
      />

      <small v-show="errors.has('client')" class="form-text text-muted">
        {{ errors.first('client') }}
      </small>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";

export default {
  name: "ArenaPointTypeForm",
  components: {
    LoaderButton,
    Combobox
  },

  props: {
    pointType: {
      type: Object,
      default: () => ({
        id: undefined,
        TPV_DSC: "",
        TPV_COD: "",
        CLI_ID: undefined
      }),
    },
  },

  computed: {
    ...mapState({
      clients: state => state.arena.clients,
    }),
  },

  methods: {
    ...mapActions("arena", ["createPointType", "editPointType"]),

    async onClick(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id, ...rest } = this.pointType;

      const result = id
        ? await this.editPointType({ id, data: rest })
        : await this.createPointType(rest);

      if (result) {
        this.$router.push({ name: "listarenapointtype" });
      }
    },
  },

  async mounted () {
    await this.$store.dispatch('arena/fetchClients')
  },
};
</script>
